import React from 'react';
import { styled } from '@mui/material/styles';
import Background from './../../images/background.svg'
import Banner from './../components/Banner';
const PREFIX = 'NotFound';

const classes = {
    root: `${PREFIX}-root`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        margin: theme.spacing(0),
        background: "url(" + Background + ") no-repeat center bottom fixed",
        backgroundSize: "cover",
    }
}));

function NotFound() {

    return (
        (<Root className={classes.root}>
            <Banner title="Page Not Found" />
        </Root>)
    );
}

export default NotFound;
